import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import AutomationRulesManager from "@/components/AutomationRulesManager";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AIActorAutomationRules() {
  const { actorId } = useParams();
  const navigate = useNavigate();
  const [actor, setActor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchActorDetails();
  }, [actorId]);

  const fetchActorDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API}/ai/actors/${actorId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setActor(response.data);
    } catch (error) {
      console.error("Failed to fetch actor details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(`/ai/actors/manage/${actorId}`);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-muted-foreground">Loading...</p>
      </div>
    );
  }

  return (
    <div className="container max-w-6xl mx-auto p-6 min-h-screen">
      {/* Header Section */}
      <div className="mb-8">
        <Button
          variant="ghost"
          onClick={handleBack}
          className="mb-4"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Manage
        </Button>
        
        <div className="text-center">
          <h1 className="text-3xl font-bold mb-2">Automation Rules</h1>
          {actor && (
            <p className="text-muted-foreground text-lg">
              {actor.name}
              {actor.experience_level && ` • ${actor.experience_level}`}
            </p>
          )}
        </div>
      </div>

      {/* Content - AutomationRulesManager Component */}
      <AutomationRulesManager actorId={actorId} />
    </div>
  );
}
